export const HANDLING_UNIT_MOVEMENT = 'HandlingUnitMovement';
export const HandlingUnitMovementTypeValues = [
    'enter',
    'exit',
    'relocate',
    'nest',
    'unnest',
    'split',
    'merge',
    'quantity-in',
    'quantity-out',
];
export const HANDLING_UNIT_MOVEMENT_TYPE_LABELS = {
    enter: 'Entrada',
    exit: 'Saída',
    relocate: 'Realocação',
    nest: 'Empacotado',
    unnest: 'Desempacotado',
    split: 'Divisão',
    merge: 'Fusão',
    'quantity-in': 'Ajuste (+)',
    'quantity-out': 'Ajuste (-)',
};
//# sourceMappingURL=handling-unit-movement.js.map